import React from "react";
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import {Consumer} from "./CreateSigntask";
import { useTranslation } from 'react-i18next';

const Reference = () => {
    const { t } = useTranslation();

    return (
        <Consumer>{({ reference, updateReference }) => (
            <FormGroup>
                <ControlLabel>{t("create_signtask_signtask_title")}</ControlLabel>
                <FormControl type="text" name="reference"
                    value={reference} onChange={event => updateReference(event.target.value)} />
            </FormGroup>
    )}</Consumer>
    );
};

export default Reference;